module.exports = __webpack_public_path__ + "static/media/sezzle_icon.61930a05.svg";